import {Header} from './Header'
import {Displayer} from './Displayer'
function App() {
  return (
    <div className="flex flex-col items-center">
      <Header />
      <Displayer/>
    </div>
  );
}

export default App;
